import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const DEFAULT_LOCALE = 'it'

// Anonymous users have no saved language yet, so pick the closest supported
// locale from the browser. Authenticated users still get their profile
// language applied afterwards (see App.vue's `user` watcher), which
// overrides whatever this resolves to.
function resolveInitialLocale(supportedLocales) {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LOCALE
  }

  const browserLocales = navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language]

  for (const browserLocale of browserLocales) {
    if (!browserLocale) continue
    const normalized = browserLocale.split('-')[0].toLowerCase()
    if (supportedLocales.includes(normalized)) {
      return normalized
    }
  }

  return DEFAULT_LOCALE
}

export default function createI18n(/* ssrContext */) {
  const messages = {
    it: require('../locales/it.json'),
    en: require('../locales/en.json'),
    es: require('../locales/es.json'),
    fr: require('../locales/fr.json'),
    zh: require('../locales/zh.json'),
    de: require('../locales/de.json'),
    pt: require('../locales/pt.json'),
  }

  return new VueI18n({
    locale: resolveInitialLocale(Object.keys(messages)),
    fallbackLocale: 'en',
    messages,
  })
}
